<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('purchaseRequestTemplate.edit') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('purchaseRequestTemplate.pageTitle'),
                    href: '/admin/purchase-request-templates'
                },
                {
                    text: $t('edit'),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <ts-loading-banner :loading="loading">
                    <form class="form-horizontal ts-space-y-3">
                        <div class="row">
                            <div class="col-md-12">
                                <Info v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="d-flex justify-content-between align-items-center ts-mb-2">
                                    <h5 class="ts-font-bold ts-mb-0">{{ $t('purchaseRequestTemplate.items') }}</h5>
                                    <button type="button" class="btn btn-success" @click="$refs.productList.show()">
                                        <i class="fa fa-plus ts-mr-1"></i> {{ $t('purchaseRequestTemplate.addItems') }}
                                    </button>
                                </div>
                                <ItemList v-model="model" :validate="errors" class="ts-border ts-rounded" />
                                <ProductList ref="productList" v-model="model" />
                            </div>
                        </div>
                        <div class="row ts-mt-4">
                            <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                                <ts-button @click.prevent="$router.push({ name: 'purchase-request-template' })">{{
                                    $t('cancel') }}</ts-button>
                                <ts-button :waiting="loading" @click.prevent="onUpdate" color="primary">{{ $t('update')
                                }}</ts-button>
                            </div>
                        </div>
                    </form>
                </ts-loading-banner>
            </ts-card-wrapper>
        </ts-card>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Info from './components/info.vue'
import ItemList from './components/item-list'
import ProductList from './components/product-list'

export default {
    name: 'templateEdit',
    components: {
        Info,
        ItemList,
        ProductList
    },
    data() {
        return {
            loading: false,
            errors: new Errors(),
            model: {
                template_name: '',
                template_description: '',
                details: []
            }
        }
    },
    computed: {
        ...mapState('purchaseRequest/template', ['edit_data'])
    },
    methods: {
        ...mapActions('purchaseRequest/template', ['getFormViewModel', 'find', 'update']),
        async getPreData({ params, index }) {
            this.loading = true
            await this.getFormViewModel({ index: index, params: params })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => (this.loading = false))
        },
        async getTemplate() {
            this.loading = true
            await this.find(this.$route.params.id)
                .then(() => {
                    this.model.template_name = this.edit_data.template_name
                    this.model.template_description = this.edit_data.template_description
                    this.model.details = this.edit_data.details.map(d => ({
                        product_id: d.product_id,
                        uom_id: d.uom_id,
                        quantity: d.quantity,
                        unit_price: d.unit_price,
                        remarks: d.remarks
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.$router.push({ name: 'purchase-request-template' })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onUpdate() {
            if (!this.model.template_name) {
                this.$toasted.error(this.$t('purchaseRequestTemplate.pleaseEnterName'))
                return
            }
            if (this.model.details.length === 0) {
                this.$toasted.error(this.$t('purchaseRequestTemplate.pleaseAddItems'))
                return
            }

            this.loading = true
            this.errors = new Errors()
            this.update({ id: this.$route.params.id, data: this.model })
                .then(response => {
                    this.$toasted.success(response.message)
                    this.$router.push({ name: 'purchase-request-template' })
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    },
    async created() {
        await this.getPreData({
            params: {},
            index: 'products,unitOfMeasures,productCategories,productGroups'
        })
        await this.getTemplate()
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('purchaseRequest/template/CLEAR_SETUP')
        this.$store.commit('purchaseRequest/template/CLEAR_EDIT_DATA')
        next()
    }
}
</script>
